import backgroundImage from "../gallery/image2.jpg";

export default function Hero() {
  return (
    <section className="@container">
      <div className="@[480px]:p-4">
        <div
          className="relative flex min-h-[540px] flex-col items-center justify-center text-center bg-cover bg-center bg-no-repeat @[480px]:rounded-xl px-6"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url(${backgroundImage})`
          }}
          aria-label="Hero background: children studying outdoors"
        >
          {/* Headline */}
          <h1 className="text-3xl md:text-4xl font-bold text-white drop-shadow-md">
            Education for All
          </h1>
          <p className="mt-3 max-w-2xl text-base md:text-lg text-white/90">
            Join us in supporting education, healthcare, and community
            support for Nomadic & Denotified Tribes.
          </p>

          {/* Button */}
          <a
            href="/about"
            className="mt-6 inline-flex items-center justify-center rounded-xl
                       bg-[#14b881] hover:bg-[#0fa46f] px-6 py-3 text-base
                       font-semibold text-[#0e1b17] shadow-md transition"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
}
